import { fromZonedTime } from '@eigtech/ui-shared-dates'

export function forceDateInputValueToTimezone(date: Date, timezone?: string) {
  return fromZonedTime(date, timezone || Intl.DateTimeFormat().resolvedOptions().timeZone)
}
